import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Coins, ArrowLeft, MailCheck } from "lucide-react";
import api, { apiErr } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md card-surface rounded-3xl p-8 glow-emerald">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Coins className="h-7 w-7 text-emerald-400" />
          <span className="text-xl font-extrabold">ERAN <span className="text-emerald-400">USD</span></span>
        </Link>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent-message">
            <MailCheck className="h-12 w-12 text-emerald-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2">Check your email</h1>
            <p className="text-sm text-slate-400">
              If <span className="text-emerald-400">{email}</span> is registered, we've sent a password
              reset link. It expires in 1 hour. Don't forget to check spam.
            </p>
            <Link to="/login" data-testid="back-to-login-link"
              className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:underline mt-6">
              <ArrowLeft className="h-4 w-4" /> Back to Login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-1 text-center">Forgot Password</h1>
            <p className="text-sm text-slate-400 text-center mb-6">Enter your email to receive a reset link</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-slate-300">Email</Label>
                <Input data-testid="forgot-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-white/5 border-slate-700"
                  placeholder="you@example.com" />
              </div>
              <Button data-testid="forgot-submit-btn" type="submit" disabled={loading}
                className="w-full rounded-full bg-emerald-500 hover:bg-emerald-600 text-white h-11">
                {loading ? "Sending…" : "Send Reset Link"}
              </Button>
            </form>
            <p className="text-sm text-slate-400 text-center mt-6">
              <Link to="/login" className="text-emerald-400 hover:underline">Back to Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
